import React,  { useState } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";


import { Checkbox, FormControlLabel, TextField,MenuItem } from "@material-ui/core";
import clsx from "clsx";
import * as auth from "../../store/ducks/auth.duck";
import { editPs
  , getMyProfile
} from "../../crud/auth.crud";

import CodeExample from "../../partials/content/CodeExample";



function EditPs(props) {
  
  console.log('Loaded CreateUser',props);
  
  const { intl } = props;
   
   let isLoaded = false;


  const [loading, setLoading] = useState(false);
  const [loadingButtonStyle, setLoadingButtonStyle] = useState({
    paddingRight: "2.5rem"
  });

 // const [user,setUser] =useState({});

   const [editUserData,setEditUser] =useState({editUser:props.location.data.user});
 

  const [user,setUser] =useState({usr:{},isLoading:false});
  
  React.useEffect(() => {
        const fetchUser = async () => {
            try {
                
                const response = await getMyProfile()
                  console.log(response.data[0]);
                  console.log("account=="+response.data[0].accountKey);
                  if (response.data[0].accountKey=="")
                  {
                    setUser({usr:response.data[0],isLoading:true});

                  }

                  console.log("user-----"+ user.isLoading);
                 
                
            } catch (e) {
                console.log(e);
                
            }
        };
        fetchUser();
    }, []);

  



  const [statusColor, setStatusColor] = useState('alert-success');

  const enableLoading = () => {
    setLoading(true);
    setLoadingButtonStyle({ paddingRight: "3.5rem" });
  };

  const disableLoading = () => {
    setLoading(false);
    setLoadingButtonStyle({ paddingRight: "2.5rem" });
  };



  return (

      <Formik
                  initialValues={{
                    password:'',
                    confirmPassword: '',
                    
                    
                  }}
                  validate={values => {
                    const errors = {};

                   

                    if (!values.password) {
                      errors.password = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.confirmPassword) {
                      errors.confirmPassword = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                   if (values.password != values.confirmPassword) {
                      errors.confirmPassword = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }
                    

                  

                   

                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting }) => {

                    enableLoading();
                    editPs(
                      {password:values.password},props.location.data.user.id
                      
                      
                    )
                      .then(resp => {
                        //props.register(accessToken);
                       
                        disableLoading();
                        setStatus(
                          intl.formatMessage({
                            id: "USER.CREATION.SUCCESS.MESSAGE"
                          })
                        );
                        setStatusColor('alert-success');
                        window.scrollTo(0,0);
                       
                      })
                      .catch(() => {
                        disableLoading();
                        setSubmitting(false);
                        setStatus(
                          intl.formatMessage({
                            id: "AUTH.VALIDATION.INVALID_LOGIN"
                          })
                        );
                        setStatusColor('alert-danger');
                      });
                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,

                   
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
                      {status && (
                        <div role="alert" className={"alert "+statusColor}>
                          <div className="alert-text">{status}</div>
                        </div>
                      )}

    <CodeExample beforeCodeTitle="Basic Details">
          <div className="kt-section">
            <div className="kt-section__content">

                     
                      <div className="form-group mb-0">
                        <TextField
                          type="password"
                          margin="normal"
                          label="Password"
                          className="kt-width-full"
                          name="password"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.password}
                          helperText={touched.password && errors.password}
                          error={Boolean(touched.password && errors.password)}
                        />
                      </div>              

                      <div className="form-group mb-0">
                        <TextField
                          type="password"
                          margin="normal"
                          label="Confirm Password"
                          className="kt-width-full"
                          name="confirmPassword"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.confirmPassword}
                          helperText={touched.confirmPassword && errors.confirmPassword}
                          error={Boolean(touched.confirmPassword && errors.confirmPassword)}
                        />
                      </div>
              
        </div>
        </div>
        </CodeExample>
        <div className="kt-login__actions">
                       

                        <button
                          disabled={isSubmitting}
                         type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading
                              }
                            )}`}
                            style={loadingButtonStyle}
                          >
                           Set Password
                        </button>
                      </div>
        </form>
         )}
                </Formik>
                
  );
}


export default injectIntl(
  connect(
    null,
    auth.actions
  )(EditPs)
);
